<section>
    <article class="flex justify-center items-center">
        <img [src]="images.pax" [ngClass]="{'cancelled': booking.cancelled}" alt="pax" class="h-6 w-6">
        <label class="ml-2" [ngClass]="{'neutrals-grey-04-text': booking.cancelled}" >{{ booking.seats }}</label>
    </article>
    <article class="flex justify-center items-center">
        <img [src]="images.prm" [ngClass]="{'cancelled': booking.cancelled}" alt="prm" class="h-6 w-6">
        <label class="ml-2" [ngClass]="{'neutrals-grey-04-text': booking.cancelled}" >{{ booking.prmSeats }}</label>
    </article>
</section>
